module.exports = __webpack_public_path__ + "img/state0.498a48fc.png";